<div class="row ss-top-menu">
	<div class="col-sm-12">
		<span class="ss-text-light">Dashboard <i class="rightArrow fa fa-angle-right"></i></span>
		<span class="ss-text-dark">Client Invoice</span>
	</div>
</div>

<div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert" style="z-index: 10000;">
	<span id="notificationMessageText">{{successMessage}}</span>
	<a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="row">
  <div class="col-6 mt-3">
    <input
              type="text"
              name="searchInput"
              class="w-100"
              placeholder="Search For Lead Id, Client Name"
              (keydown.enter)="searchFilter($event)"
            />
  </div>  
</div>
<div class="invoice-types">
  <button type="button" target="_self" class="btn btn-invoice" (click)="changeProjectStatus(pendingStatus)" [ngClass]="{'active':currentProjectStatus==pendingStatus}">Pending Invoices<span class="badge">{{pendingProjectCount}}</span></button>
  <button type="button" target="_self" class="btn btn-invoice" (click)="changeProjectStatus(releasedStatus)" [ngClass]="{'active':currentProjectStatus==releasedStatus}">Completed<span class="badge">{{releasedProjectCount}}</span></button>
</div>

<!-- <div class="col-md-12 bg-white rounded-left">
    <span class="text-secondary">Filter By:</span>&nbsp;&nbsp;&nbsp;

    <ng-select  (change)="filterColumDropdownChange1($event)"  id="filter1dropdown" placeholder="Select Client" style="width:17%;display:inline-block;vertical-align: middle">
          <ng-option value="{{ item.id }}" *ngFor="let item of leadList">{{ item.name }}</ng-option>
    </ng-select>
    
    <div class="form-check">
      <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter From Date" class="form-control form-control-change" [(ngModel)]="fromDate" (dateTimeChange)="takeFromDate($event)">
        <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time> 
    </div>
    <div class="form-check">
      <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter To Date" class="form-control form-control-change" [(ngModel)]="toDate" (dateTimeChange)="takeToDate($event)">
        <owl-date-time #dt2 [pickerType]="'calendar'" ></owl-date-time> 
    </div>  
    <div class="col-md-1 bg-white rounded-right display-inline">
      <img src="assets/img/dashboard/submit.png" class="ml-1 my-3 sendIcon filterRowIcon cursor-pointer" (click)="filterData()"> 
    </div>
        
  </div> -->

<div class="panel-group" id="accordion">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="panel-title">
            <table class="table">
              <thead style="background-color:whitesmoke">
                <tr>
                  <th></th>
                  <th>Lead ID</th>
                  <th>Client Name</th>
                  <th>Designer + <br/> Community Manager</th>
                  <th>% of Payment Collected</th>
                  <th>Total BOQ Value</th>
                  <th></th>
                  <th ></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let project of projectLineItems  | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index; ">
                <tr (click)="checkAccordionStatus(i,projectLineItems.length,project)" class="accordion-row" data-toggle="collapse" data-parent="#accordion" >
                    <td *ngIf="!isAccordionActive[i]"><i class="fa fa-chevron-down"></i></td>
                    <td *ngIf="isAccordionActive[i]"><i class="fa fa-chevron-up"></i></td>
                    <td>{{project?.project_info?.lead_id}}</td>
                    <td>{{project?.project_info?.lead_name}}</td>
                    <td>{{project?.project_info?.designer}} + <br/> {{project?.project_info.cm}}</td>
                    <td>{{project?.project_info?.paid_amount?.toFixed(3) | currency: 'INR':"symbol" }}( <span *ngIf="!project.project_info?.total_amount" class="highlight">N.A</span> <span *ngIf="project.project_info?.total_amount" class="highlight">{{((project?.project_info.paid_amount/project.project_info?.total_amount)*100)?.toFixed(3)}}% </span>)</td>
                    <td>{{project?.project_info?.total_amount?.toFixed(3) | currency: 'INR':"symbol" }}</td>
                    <td></td>
                    <td class="payment-history-icon" data-toggle="modal" data-target="#payment-details" (click)="stopPropagation($event,'payment',project?.project_info?.project_id,project?.project_info)">&#9432;</td>
                    <td><button type="button" target="_self" data-toggle="modal" data-target="#view-invoices" class="btn btn-arrivae" (click)="stopPropagation($event,'invoice',project?.project_info?.project_id,project?.project_info)">View All Invoices</button></td>
                    <td><button type="button" target="_self" data-toggle="modal" class="btn btn-arrivae" data-target="#create-invoices" (click)="stopPropagation($event,'create-invoices',project?.project_info?.project_id,project?.project_info)">Create Invoice</button></td>
                </tr>
                <!-- <tr id="{{'collapse'+i}}" class="panel-collapse collapse in" >
                  <td colspan="10" class="border-design">
                    <table class="table borderless">
                      <thead>
                        <tr>
                          <th>BOQ Number</th>
                          <th>Space</th>
                          <th>Type</th>
                          <th>Segment</th>
                          <th>Line Item</th>
                          <th>Quantity</th>
                          <th>Full Value After Discount</th>
                          <th>50% Collection Date</th>
                          <th>Invoice Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let boq of project.project_info.line_items" >
                          <td class="highlight">{{boq?.boq_number}}</td>
                          <td>{{boq?.space}}</td>
                          <td>{{boq?.job_type}}</td>
                          <td>{{boq?.job_segment | replaceChar}}</td>
                          <td>{{boq?.job_name}}</td>
                          <td>{{boq?.job_quantity}}</td>
                          <td>{{boq?.job_amount?.toFixed(2) | currency: 'INR':"symbol"}}</td>
                          <td>{{(boq?.fifty_approved_date | date) || '-'}}</td>
                          <td class="capitalize">{{boq?.invoice_status || '-'}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr> -->
              <!-- New Implementation-->
              <tr id="{{'collapse'+i}}" class="panel-collapse collapse in" style="background-color: azure; border: 2px solid #8d0528;">
                <td colspan="10" class="border-design">
              <div class="col-md-12 pt-3 pb-3">
                <div id="accordionLf">
                  <div class="card mb-2" *ngFor="let obj of lineItemKey; let k2=index; ">
                    <div class="card-header" id="spaceCardLf{{k2}}{{i}}">
                      <h5 class="mb-0">
                        <button class="btn mb-3 mt-3 fontsize1 addCursor1 text-capitalize" data-toggle="collapse"
               aria-expanded="false" [attr.aria-controls]="'collapseSpaceCardLfs'+k2+i" [attr.data-target]="'#collapseSpaceCardLfs'+k2+i" (click)="checkitemkey(obj, project, k2,i)">
                {{transform(obj)}}
              </button>
                      </h5>
                    </div>
              
                    <div class="accordion-group">   
              <div id="collapseSpaceCardLfs{{k2}}{{i}}" class="collapse" [attr.aria-labelledby]="'spaceCardLf'+k2+i"
            data-parent="#accordionLf">
                <div class="card-body" style="border: 2px solid #8d0528;">
                      <div>
                        <table class="table">
                          <thead style="background-color: #212529; color:#ffffff;">
                            <tr class="align-tr">
                              <th>BOQ Number</th>
                              <th>Space</th>
                              <th>Type</th>
                              <th>Segment</th>
                              <th>Line Item</th>
                              <th>Quantity</th>
                              <th>Full Value After Discount</th>
                              <th>50% Collection Date</th>
                              <th>Invoice Status</th>
                            </tr>
                          </thead>
                          <tbody class="subline-parameter" >
                            <tr *ngFor="let item of this.obj_array" [ngStyle]="{'background-color': (item.can_select === false) ? 'silver' : '#fff' }">
                              <td>{{item.boq_number}}</td>
                              <td>{{item.space}}</td>
                              <td>{{item.job_type}}</td>
                              <td>{{item.job_segment | replaceChar}}</td>
                              <td>{{item.job_name}}</td>
                              <td>{{item.job_quantity}}</td>
                              <td>{{item.job_amount?.toFixed(3) | currency: 'INR':"symbol"}}</td>
                              <td>{{item.fifty_approved_date | date:'dd/MM/yyyy'}}</td>
                              <td>{{item.invoice_status}}</td>
                            </tr>
                          </tbody>
                        </table>
                </div>
                </div>
                </div>
                </div>
                  </div>
              </div>
                </div>
              <!--For Testing-->
              <!-- <div class="accordion" id="accordionExample">
                <div class="card">
                  <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                      <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapsesOne" aria-expanded="true" aria-controls="collapseOne">
                        Collapsible Group Item #1
                      </button>
                    </h2>
                  </div>
              
                  <div id="collapsesOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                      Some placeholder content for the first accordion panel. This panel is shown by default, thanks to the <code>.show</code> class.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header" id="headingTwo">
                    <h2 class="mb-0">
                      <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapsesTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Collapsible Group Item #2
                      </button>
                    </h2>
                  </div>
                  <div id="collapsesTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                    <div class="card-body">
                      Some placeholder content for the second accordion panel. This panel is hidden by default.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header" id="headingThree">
                    <h2 class="mb-0">
                      <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapsesThree" aria-expanded="false" aria-controls="collapseThree">
                        Collapsible Group Item #3
                      </button>
                    </h2>
                  </div>
                  <div id="collapsesThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                      And lastly, the placeholder content for the third and final accordion panel. This panel is hidden by default.
                    </div>
                  </div>
                </div>
              </div> -->

              <!--Ends Here Testing 3.6-->
              
              </td>
            </tr>
              
                <!--ENds Here-->
              </ng-container>
              </tbody>
            </table>
            <div class="col-12 not-found" *ngIf="projectLineItems && projectLineItems.length==0">
              <div class="boq-img text-center">
                <img src="../../../assets/img/desktop.png"/>
              </div>
              <p class="nothing-to-show pb-4">Nothing to show...</p>
            </div>
            <div class="text-center pagination-size" *ngIf="projectLineItems && projectLineItems.length >0">
              <pagination-controls autoHide="true" (pageChange)="current_page = getProjectLineItemsDetails($event,this.fromDate,this.toDate,this.clientId)"></pagination-controls>
            </div>
      </h4>
    </div>
  </div>
</div>

<!-- Payment History -->
<div class="modal fade" id="payment-details" role="dialog">
    <div class="modal-dialog">
    
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Payment History</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <collapsible-table [type]="'accordion'" bordered class="table">
            <thead>
              <collapsible-table-row>
                <th>#</th>
                <th>DATE/DATE OF CHEQUE</th>
                <th>PAYMENT MODE</th>
                <th>DATE OF ADDING PAYMENTS</th>
                <th>PAID AMT (BY CUSTOMER)</th>
                <th>TRANSACTION NUMBER</th>
                <th>FINANCE STATUS</th>
                <th>FINANCE VERIFICATION DATE</th>
                <!-- <th>PAYMENT TYPE</th> -->
                <th>PREVIEW UPLOADED IMAGE</th>
              </collapsible-table-row>
            </thead>
            <tbody>
              <ng-container *ngFor="let history of paymentHistoryByProject;let historyIndex = index" >
              <collapsible-table-row [detail]="boqDetail" >
                <td>{{historyIndex + 1}}</td>
                <td>{{(history?.date_of_cheque | date) || '-'}}</td>
                <td>{{history?.mode_of_payment || '-'}}</td>
                <td>{{(history?.created_at | date)  || '-'}}</td>
                <td>{{(history?.amount | currency: 'INR':"symbol" ) || '-'}}</td>
                <td>{{history?.transaction_number || '-'}}</td>
                <td>{{history?.finance_status  || '-'}}</td>
                <td>{{(history?.finance_approved_at | date) || '-'}}</td>
                <!-- <td>{{(history?.payment_type | replaceChar)  || '-'}}</td> -->
                <td *ngIf="history.image && history.image!='/images/original/missing.png'"><a href={{history?.image}} target="_blank"><i class="fas fa-image arrivae-color"></i></a></td>
                <td *ngIf="history.image=='/images/original/missing.png'">-</td>
              </collapsible-table-row>
              <collapsible-table-row-detail #boqDetail>
                <table class="complete-width">
                  <thead>
                    <tr class="table-row">
                      <th scope="col">REF NO.</th>
                      <th scope="col">BOQ VALUE</th>
                      <th scope="col">APPORTIONED PAYMENT VALUE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let boqDetails of history?.quotation_payments">
                      <td class="capitalize">{{boqDetails.boq_reference_number}}</td>
                      <td>{{boqDetails.boq_total_amount | currency: 'INR':"symbol"}}</td>
                      <td >{{boqDetails.approtioned_payment_value | currency: 'INR':"symbol"}}</td>
                    </tr>
                  </tbody>
                </table>
              </collapsible-table-row-detail> 
            </ng-container>
            </tbody>
          </collapsible-table>
        </div>
      </div>
    </div>
  </div>

<!-- View Invoices -->
<div class="modal fade" id="view-invoices" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header invoice-modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="search-container mb-2 form-group">
          <!-- <a href={{invoice?.download_link}} download><i class="fa fa-download donwload-icon"></i></a> -->
          <form [formGroup]="search" class="search-box">
            <input type="text" placeholder="Search.." formControlName="invoiceSearchValue" class="form-control ml-4 " name="search">
          </form>
        </div>
        <ng-container *ngIf="allInvoices.length>0">
          <table class="table">
            <thead>
              <tr>
                <th>Invoice Number</th>
                <th></th>
                <th>Invoice Creation Date</th>
                <th>Status</th>
                <th>Sharing Date</th>
                <th>Lead ID and Client Name</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let invoice of allInvoices">
                  <td>{{invoice?.invoice_number}}</td>
                  <!-- <td *ngIf="invoice?.status!='released'"><i class="fa fa-pencil" (click)="callCreateInvoice()"></i></td> -->
                  <td *ngIf="invoice?.status=='released'"></td>
                  <td *ngIf="invoice?.status!='released'"><i class="fa fa-pencil" (click)="callCreateInvoice(invoice.id)"></i></td>
                  <td>{{(invoice?.creation_at | date) || '-'}}</td>
                  <td class="capitalize">{{invoice?.status}}</td>
                  <td>{{(invoice?.sharing_date | date) || '-'}}</td>
                  <td>{{invoice?.lead_id}} & {{invoice?.lead_name}}</td>
                  <td><i (click)="shareInvoice(invoice?.id)" class="fa fa-share-alt" data-toggle="tooltip" title="Share Invoice"></i></td>
                  <!-- <td><a><button (click)="downloadInvoice(invoice?.id,'preview')" type="button" class="btn btn-arrivae">Preview</button></a></td> -->
                  <td><a><button (click)="previewInvoice(invoice.file_url)" type="button" class="btn btn-arrivae">Preview</button></a></td>
                  <!-- <td><i class="fa fa-download donwload-icon" (click)="downloadInvoice(invoice?.id,'download')" data-toggle="tooltip" title="Download"></i></td> -->
                  <td><a data-toggle="tooltip" title="Download" [href]="invoice.file_url" target="_blank" download><i class="fa fa-download donwload-icon" ></i></a></td>
                </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-container *ngIf="allInvoices.length==0">
          <div class="align-image">
            <img src="../../../assets/img/nothing.png">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Create Invoices -->
<div class="modal fade overflow-invoice" id="create-invoices" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header invoice-modal-header">
          <button type="button" class="close" (click)="closeCreateInvoice()">&times;</button>
        </div>
        <div class="modal-body">
            <!-- <app-dashboard [projectId]="currentProjectId"></app-dashboard> -->
            <app-create-invoice [childInvoice]="childInvoiceDetails" [projectDetails]="currentProjectDetails" [currentPage]="current_page" [projectId]="currentProjectId" [currentStatus]="this.currentProjectStatus" [currentInvoice]="this.currentInvoice" ></app-create-invoice>
        </div>
      </div>
    </div>
</div>
<div class="modal-container">
  <div class="modal" id="preview-invoice">
      <div class="modal-dialog modal-lg" style="max-width:890px">
        <div class="modal-content">
    
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Preview Invoice</h4>
            <button type="button" class="close" (click)="closePreviewInvoice()" >&times;</button>
          </div>
          <div class="modal-body">
            <!-- <iframe *ngIf="currentInvoiceBase64" [src]="sanitize(currentInvoiceBase64)" width = "850" height = "600" > -->
            <iframe *ngIf="currentDownloadLink" [src]="sanitize(currentDownloadLink)" width = "850" height = "600" >
          </iframe>
    
          </div>
        </div>
      </div>
    </div>
</div>
  



// WEBPACK FOOTER //
// ./src/app/platform/finance/client-invoice/client-invoice.component.html